import { useEffect, useState } from 'react';

import { RegExStrings } from '../lib/util/DataHelpers';

const useIsSafari = (): boolean => {
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    const { userAgent } = navigator;
    const isSafariBrowser = RegExStrings.safari.test(userAgent)
      && !RegExStrings.chrome.test(userAgent); // Exclude Chrome and Firefox on iOS
    setIsSafari(isSafariBrowser);
  }, []);

  return isSafari;
};

export default useIsSafari;
